export default __webpack_public_path__ + "static/media/2001.e56674e0.png";